// FeesStructurePDF.jsx
import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontSize: 9,
    fontFamily: "Helvetica",
  },

  // ===== HEADER =====
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
  },
  logoContainer: {
    width: "10%",
    alignItems: "flex-start",
  },
  logo: {
    width: 45,
    height: 45,
    marginBottom: 6,
  },
  textContainer: {
    width: "90%",
    alignItems: "center",
  },

  title: { fontSize: 13, fontWeight: "bold", textAlign: "center" },
  subtitle: {
    fontSize: 11,
    fontWeight: "bold",
    marginTop: 3,
    textAlign: "center",
  },

  // ===== TABLE =====
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 15,
  },
  row: {
    flexDirection: "row",
  },
  th: {
    width: "9.09%", // 11 columns => 100 / 11
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    fontSize: 9,
  },
  td: {
    width: "9.09%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
    fontSize: 9,
  },
});

const FeesStructurePDF9 = ({ tableData }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        {/* Logo Left */}
        <View style={styles.logoContainer}>
          <Image src="/assets/images/jac.png" style={styles.logo} />
        </View>

        {/* Title + Subtitle Center */}
        <View style={styles.textContainer}>
          <Text style={styles.title}>JHARKHAND ACADEMIC COUNCIL, RANCHI</Text>
          <Text style={styles.subtitle}>
            Fees Structure of Class IX Registration - 2026 (Annual)
          </Text>
        </View>
      </View>

      {/* Table */}
      <View style={styles.table}>
        {/* Table Head */}
        <View style={styles.row}>
          <Text style={styles.th}>#</Text>
          <Text style={styles.th}>Candidate Category</Text>
          <Text style={styles.th}>Gender</Text>
          <Text style={styles.th}>ODPPM Fee</Text>
          <Text style={styles.th}>Registration Fee 1</Text>
          <Text style={styles.th}>Registration Fee 2</Text>
          <Text style={styles.th}>Permission Fee</Text>
          <Text style={styles.th}>Examination Fee</Text>
          <Text style={styles.th}>Total Fees (Before Start of Late Fine)</Text>
          <Text style={styles.th}>Late Fee</Text>
          <Text style={styles.th}>Total Fees (After Start of Late Fine)</Text>
        </View>

        {/* Table Body */}
        {tableData.map((item, index) => (
          <View style={styles.row} key={index}>
            <Text style={styles.td}>{index + 1}</Text>
            <Text style={styles.td}>{item.candidatE_TYPE}</Text>
            <Text style={styles.td}>{item.candidatE_CATEGORY}</Text>
            <Text style={styles.td}>{item.odppM_FEE}</Text>
            <Text style={styles.td}>{item.registratioN_FEE_1}</Text>
            <Text style={styles.td}>{item.registratioN_FEE_2}</Text>
            <Text style={styles.td}>{item.permissioN_FEE}</Text>
            <Text style={styles.td}>{item.examinatioN_FEE}</Text>
            <Text style={styles.td}>{item.beforE_LATE_TOTAL_FEE}</Text>
            <Text style={styles.td}>{item.latE_FEE}</Text>
            <Text style={styles.td}>{item.afteR_LATE_TOTAL_FEE}</Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default FeesStructurePDF9;
